<div #legalCoverBenefitsDesktopOffcanvas class="offcanvas offcanvas-end" tabindex="-1" [id]="content?.id"
  [attr.aria-labelledby]="(content?.id ||'offcanvas')+'Label'">
  <div class="offcanvas-header header-sec">
    <div class="heading">Your cover & benefits</div>
    <button type="button" id="" name="" class="btn-close text-reset pt-2" (click)="closeOffcanvas()"></button>
  </div>
  <div class="offcanvas-body px-3">
    <div class="block-sec">
      <div class="head text-start">Your policy benefits</div>
      <div class="divider_yellow"></div>
      <ul>
        <li>The Policy ensures you and your spouse have access to  <span class="font-weight-bold">legal advice, assistance, and legal representation for civil, criminal, and labour-related matters.</span>
        </li>
        <div class="border-li"></div>
        <li>We will provide cover and pay Claims for legal expenses incurred as a result of <span class="font-weight-bold">Insured Matters</span> occurring <span class="font-weight-bold">after the Policy Start Date</span> to you, or in respect of you and your partner, in South Africa for the duration of the Policy Term, <span class="font-weight-bold">subject at all times to payment of the Premiums</span> due in terms of this Policy.
        </li>
        <div class="border-li"></div>
        <li>Payment of such Claims, subject to the Insured Sum, will be paid <span class="font-weight-bold">directly to the legal service provider/attorney firm</span> who has been duly approved and appointed by JustMoney Protect to represent you in a legal matter.
        </li>
        <div class="border-li"></div>
        <li>
          Your Policy ends when your policy lapses due to <span class="font-weight-bold">non-payment</span> of your premium, <span class="font-weight-bold">gets cancelled</span> by either party or on your <span class="font-weight-bold">death.</span>
        </li>
        <div class="border-li"></div>
        <li>Maximum number of criminal cases: <span class="font-weight-bold">3</span>
        </li>
        <div class="border-li"></div>
        <li>Your Policy will <span class="font-weight-bold">renew automatically every year</span> on the anniversary of the Policy start date, unless you choose not to renew it.
        </li>
      </ul>
    </div>
    <div class="block-sec">
      <div class="head text-start">Your cover</div>
      <div class="divider_yellow"></div>
      <ul class="policy-list">
        <li>Annual Cover: <span class="font-weight-bold">R {{PolicyDetailResponse?.insuredSum?? 0 | number:'1.0-2'}}</span>
        </li>      
      </ul>
    </div>
    <div class="block-sec">
      <div class="head text-start">Limitations & exclusions</div>
      <div class="divider_yellow"></div>
      <ul>
        <li>Termination of Benefits: Your legal insurance benefits end upon <span class="font-weight-bold">non-payment of premium or cancellation</span> by JustMoney Protect or you.
        </li>
        <div class="border-li"></div>
        <li>Eligibility Criteria:
          <ul>
            <li>
              You must be <span class="font-weight-bold">18</span> years of age or older; <span class="font-weight-bold">and</span>
            </li>
            <li>
              You must be a permanent lawful South African citizen who ordinarily resides in South Africa; <span class="font-weight-bold">or</span>
            </li>
            <li>
              You must be a permanent resident of South Africa residing permanently and lawfully in South Africa.
            </li>
          </ul>
        </li>
        <div class="border-li"></div>
        <li>Exclusions: We will not pay a claim if the claim event is:
          <ul>
            <li>
              A pre-existing matter or event.
            </li>
            <li>
              Charges or potential charges for Violent Criminal Offences of which you are accused.
            </li>
            <li>
              An event which originated outside the borders of South Africa.
            </li>
          </ul>

        </li>
    
      </ul>
    </div>
    <div class="block-sec-footer">
      Individually issued policy document T&C's take precedence over the generalised information provided in your insurance
      summary.
    </div>
  </div>
</div>
